module.exports = __webpack_public_path__ + "img/motor_no48.06a1a7c1.jpg";